import squareItem from "./squareTrampolino.png";
import roundItem from "./roundTrampolino.png";
import squirlceItem from "./squircleTrampolino.png";

export const tableTypes =  {squareItem, roundItem, squirlceItem}